module.exports = __webpack_public_path__ + "static/img/title-pk-2.5afb896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/title-pk-2.png
// module id = TtCW
// module chunks = 1